import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import colorJson from '../../assets/colors.json';

export default class Assets {
  static instance;

  constructor() {
    if (Assets.instance) {
      return Assets.instance;
    }
    Assets.instance = this;

    this.loader = new GLTFLoader();
    this.textureLoader = new THREE.TextureLoader();

    this.assets3D = {};
    this.assets2D = {};
    this.grounds = [];
    this.logo;

    this.assetsAlreadyLoaded = false;

    this.loadModel();
    this.loadTextures();
    this.loadGrounds();
    this.loadLogo();
  }

  loadModel() {
    this.loader.load('./models.glb', (gltf) => {
      const scene = gltf.scene;

      for (const mesh of scene.children) {
        mesh.castShadow = true;
        mesh.receiveShadow = true;
      }

      this.assets3D = {
        194: {
          34: scene.children.find((child) => child.name === '194_34'),
          64: scene.children.find((child) => child.name === '194_64'),
          94: scene.children.find((child) => child.name === '194_94'),
        },
        232: {
          34: scene.children.find((child) => child.name === '232_34'),
          64: scene.children.find((child) => child.name === '232_64'),
          94: scene.children.find((child) => child.name === '232_94'),
        },
        tablet: {
          34: scene.children.find((child) => child.name === 'tab34'),
          64: scene.children.find((child) => child.name === 'tab64'),
          94: scene.children.find((child) => child.name === 'tab94'),
        },
        pandering: {
          34: scene.children.find((child) => child.name === 'bar34'),
          64: scene.children.find((child) => child.name === 'bar64'),
          94: scene.children.find((child) => child.name === 'bar94'),
        },
        drawer: {
          34: scene.children.find((child) => child.name === 'drawer34'),
          64: scene.children.find((child) => child.name === 'drawer64'),
          94: scene.children.find((child) => child.name === 'drawer94'),
        },
      };

      this.newLoad();
    });
  }

  loadTextures() {
    for (const color of colorJson) {
      const newColor = {
        id: color.id,
        name: color.name,
        file: color.file,
        map: this.textureLoader.load(`./colors/${color.file}`, () => {
          this.newLoad();
        }),
      };
      this.assets2D[color.id] = newColor;
    }
  }

  loadGrounds() {
    const path = require.context(`../../assets/grounds`, true, /(\.|\/)(jpeg|jpg)$/i);
    const local = this;

    path.keys().forEach(function (key) {
      const file = key.slice(2);

      const texture = local.textureLoader.load(require(`../../assets/grounds/${file}`), () => {
        local.newLoad();
      });
      texture.wrapS = THREE.RepeatWrapping;
      texture.wrapT = THREE.RepeatWrapping;
      texture.repeat.set(10, 10);

      local.grounds.push({
        file: file,
        map: texture,
      });
    });
  }

  loadLogo() {
    this.logo = this.textureLoader.load(require('../../assets/logo.png'), () => {
      this.newLoad();
    });
  }
}
